module.exports = __webpack_public_path__ + "img/home_class_delete_normal.a9c0f352.svg";